module.exports = __webpack_public_path__ + "img/HeiGIT_Logo_compact.0d6d3ef4.svg";